<template>
  <div class="login-footer">
    <div class="login-footer-left">
      &copy; SAPICO {{ new Date().getFullYear() }}
    </div>
    <div class="login-footer-middle">
      ENEA S.A.
    </div>
    <div class="login-footer-right">
      <a target="_blank" :href="footerUrl">{{ t('login.seeMore') }}</a>
    </div>
    <div class="login-footer-right-max">
      <a target="_blank" href="/files/Dane_osobowe_i_cookies.pdf">{{
        t('login.cookiesInfo') }}</a>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { t } from '@/setup/i18n-setup'

export default {
  name: 'PasswordPageFooter',
  inject: ['settings'],
  setup() {
    return {};
  },
  data() {
    return {

    };
  },
  mounted() {

  },
  created() {

  },
  computed: {
    footerUrl() {
        return this.settings.FOOTER_PAGE_URL
    }
  },
  methods: {
        t,

  },
  watch: {

  }
}
</script>
